import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  MenuItem,
  // TextField,
} from '@material-ui/core';
import mobile from 'is-mobile';
import Icon from '../elements/Icon';
import TextField from '../elements/TextField';

const ComponentStyled = styled(TextField)`
  &.MuiFormControl-root {
    /* min-width: 200px; */
  }
  .MuiSelect-select.MuiSelect-select,
  label {
    padding-right: 39px;
  }
  .MuiInputBase-root {
    color: ${({ theme }) => theme.colors.white};
    i {
      position: absolute;
      right: 15px;
    }
    .MuiInputAdornment-root {
      position: absolute;
      right: 20px;
    }
  }
`;

const Select = ({
  options = [],
  value,
  onChange = () => {},
  inputRef,
  formControl,
  name,
  rules,
  arialLabel,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState(value);
  useEffect(() => setSelectedValue(value), [value]);

  return (
    <ComponentStyled
      fullWidth
      value={selectedValue}
      onChange={e => {
        setSelectedValue(e.target.value);
        onChange(e);
        if (formControl && name) {
          formControl.setValue(name, e.target.value);
          formControl.trigger(name);
        }
      }}
      select
      {...props}
      SelectProps={{
        native: mobile(),
        IconComponent: () => <Icon icon={['far', 'chevron-down']} />,
        inputProps: {
          name,
        },
        inputRef: inputRef || formControl?.register({ name }, rules),
        // MenuProps: {
        //   anchorOrigin: {
        //     vertical: 'bottom',
        //     horizontal: 'left',
        //   },
        //   PaperProps: {
        //     component: MenuStyled,
        //     style: {
        //       marginTop: selectedValue ? 55 : 45,
        //     },
        //     elevation: 0,
        //   },
        // },
      }}
      inputProps={{
        'aria-label': arialLabel,
      }}
    >
      {mobile()
        ? options.map(item => (
            <option
              key={item.value}
              value={item.value}
              disabled={item.disabled}
            >
              {item.label}
            </option>
          ))
        : options.map(item => (
            <MenuItem
              key={item.value}
              value={item.value}
              disabled={item.disabled}
            >
              {item.label}
            </MenuItem>
          ))}
    </ComponentStyled>
  );
};

Select.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
  inputRef: PropTypes.func,
  formControl: PropTypes.object,
  name: PropTypes.string,
  rules: PropTypes.object,
  arialLabel: PropTypes.string,
};

export default Select;
